import { Button } from "react-bootstrap";

const ChatList = ({ awaitingChats, joinChat, joiningChatId, openChats }) => {
    return (
        <table id="allChatsTable" className="table table-striped table-bordered">
            <thead>
                <tr>
                    <th>Client Name</th>
                    <th>Created At</th>
                    <th>Last User Message</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {awaitingChats.map((chat) => {
                    const utcDateString = chat.createdAt;  // Add 'Z' to indicate UTC
                    const createdAtDate = new Date(utcDateString).toLocaleString("en-GB", {
                        weekday: "long",
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    });
                    return (
                        <tr key={chat.id}>
                            <td>{chat.firstName} {chat.familyName}</td>
                            <td>{createdAtDate}</td>
                            <td>
                                {chat.lastUserMessage ? (
                                    <>
                                        <div>{chat.lastUserMessage.message}</div>
                                        <div className="text-muted" style={{ fontSize: "0.85em" }}>
                                            {new Date(chat.lastUserMessage.sentAt).toLocaleString("en-GB", {
                                                weekday: "short",
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                            })}
                                        </div>
                                    </>
                                ) : (
                                    <span className="text-muted">No messages sent by the user</span>
                                )}
                            </td>

                            <td>
                                <Button className="me-3" variant="primary" onClick={() => joinChat(chat.id)} disabled={joiningChatId !== null || openChats.length > 2}>
                                    {openChats.length > 2
                                        ? 'Max chats open'
                                        : joiningChatId === chat.id
                                            ? 'Opening Chat...'
                                            : 'Join Chat'}
                                </Button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default ChatList;
